<button
  #button
  [type]="type"
  [disabled]="disabled"
  [tabindex]="tabIndex">

  <ng-content></ng-content>

</button>
